/* eslint-disable @next/next/no-img-element */
'use client'
import { Icon } from '@/components'
import { URL_ICON } from '@/constants/ui'
import { useVoucherContext } from '@/features/coupon/contexts/voucher-context'
import { usePromotionWithoutCart } from '@/features/coupon/hooks/use-promotion'
import { useProductDetailV2State } from '@/features/products/contexts/product-detail'
import { getVND } from '@/utils/helpers'
import {
  Box,
  Skeleton,
  Stack,
  StackProps,
  SvgIconProps,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { useMemo } from 'react'

interface Props {
  props?: Omit<StackProps, 'children'>
  iconProps?: Omit<SvgIconProps, 'children'>
  textProps?: Omit<TypographyProps, 'children'>
  showIcon?: boolean
  finalOption?: {
    text?: string
    hide?: boolean
    icon?: any
  }
  showPreText?: boolean
}

export const DiscountText = ({
  props,
  iconProps,
  textProps,
  showIcon = true,
  finalOption = { hide: false, text: 'Đây là combo hời nhất cho anh em!', icon: null },
  showPreText = false,
}: Props) => {
  const { setQuantity, tempQuantityWithCoupon } = useProductDetailV2State()
  const { listPromotionProps, caculatedQuantity } = useVoucherContext()
  const theFirstValidCoupon = useMemo(() => {
    if (!tempQuantityWithCoupon || tempQuantityWithCoupon?.length === 0) return null
    const data = tempQuantityWithCoupon?.find((item) => item.qty > caculatedQuantity)
    return data
  }, [caculatedQuantity, tempQuantityWithCoupon])

  const { data } = usePromotionWithoutCart({ ...listPromotionProps, qty: theFirstValidCoupon?.qty || 1 })

  const price = useMemo(() => {
    return data?.data?.single_price
  }, [data])

  const handleApplyCoupon = () => {
    if (theFirstValidCoupon) {
      // setQuantity(theFirstValidCoupon?.qty - currentItemsInCart)
      setQuantity(theFirstValidCoupon?.qty)
    }
  }
  const theFinalOption = useMemo(() => {
    return tempQuantityWithCoupon?.[tempQuantityWithCoupon?.length - 1]?.qty == caculatedQuantity
  }, [caculatedQuantity, tempQuantityWithCoupon])

  // last offer khi đã đạt số lượng áo cuối cùng
  // const theLastOffer = useMemo(() => {
  //   if (!tempQuantityWithCoupon || tempQuantityWithCoupon.length === 0) return null
  //   return (
  //     tempQuantityWithCoupon?.filter((item) => item?.qty <= currentItemsInCart).pop()?.qty ==
  //     tempQuantityWithCoupon?.[tempQuantityWithCoupon?.length - 1]?.qty
  //   )
  // }, [currentItemsInCart, tempQuantityWithCoupon])

  const isHide = !theFirstValidCoupon && !theFinalOption
  const TempIcon = finalOption?.icon
  return (
    <AnimatePresence>
      <Stack direction={'row'} alignItems="center" flexWrap="wrap">
        {/* <PreText showText={showPreText} text={(theFinalOption || theLastOffer) ? finalOption?.text : undefined} /> */}
        <PreText showText={showPreText} text={theFinalOption ? finalOption?.text : undefined} />
        <Stack
          alignItems={'center'}
          direction={'row'}
          gap={1}
          {...props}
          sx={{
            fontSize: '14px',
            color: 'five.main',
            opacity: isHide ? 0 : 1,
            transition: 'all 0.3s ease-in-out',
            cursor: isHide ? 'default' : 'text',
            ...props?.sx,
          }}
        >
          {showIcon && !finalOption?.icon && (
            <Icon.Discount {...iconProps} sx={{ fontSize: '1.125em', color: 'inherit', ...iconProps?.sx }} />
          )}
          {/* trường hợp đặc biệt cho option cuối cùng */}
          {theFinalOption && finalOption?.icon && (
            <TempIcon sx={{ fontSize: '1.125em', color: 'inherit', ...iconProps?.sx }} />
          )}
          {theFirstValidCoupon && (
            <Typography
              fontWeight={600}
              component={motion.p}
              {...textProps}
              sx={{ color: 'inherit', fontSize: 'inherit', ...textProps?.sx }}
            >
              Mua thêm{' '}
              <Box
                component="span"
                sx={{
                  display: 'inline-block',
                  fontWeight: 600,
                  color: 'error.main',
                  animation: 'scalePulse 1s ease-out infinite',
                  '@keyframes scalePulse': {
                    '0%': {
                      transform: 'scale(0.8)',
                      opacity: 0,
                    },
                    '60%': {
                      transform: 'scale(1.4)',
                      opacity: 1,
                    },
                    '100%': {
                      transform: 'scale(1)',
                    },
                  },
                }}
              >
                {theFirstValidCoupon?.qty ? theFirstValidCoupon?.qty - caculatedQuantity : 0}
              </Box>{' '}
              để giảm còn{' '}
              <Box
                component="span"
                sx={{
                  display: 'inline-block',
                  fontWeight: 600,
                  color: 'error.main',
                  // animation: 'scalePulse 1s ease-out infinite',
                  '@keyframes scalePulse': {
                    '0%': {
                      transform: 'scale(0.8)',
                    },
                    '60%': {
                      transform: 'scale(1.01)',
                      opacity: 1,
                    },
                    '100%': {
                      transform: 'scale(1)',
                    },
                  },
                }}
              >
                {getVND(price || 0, 'Đ')}
              </Box>
              /sản phẩm{' '}
              {theFirstValidCoupon?.qty && (
                <Tooltip placement="right" title={'Click để áp dụng số lượng'} arrow>
                  <Box
                    component="span"
                    fontWeight={400}
                    sx={{
                      textDecoration: 'underline',
                      color: 'primary.main',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      fontWeight: 600,
                    }}
                    onClick={handleApplyCoupon}
                  >
                    Áp dụng
                  </Box>
                </Tooltip>
              )}
            </Typography>
          )}
          {theFinalOption && !finalOption?.hide && (
            <Typography
              fontWeight={600}
              component={motion.p}
              {...textProps}
              sx={{ color: 'inherit', fontSize: 'inherit', ...textProps?.sx }}
            >
              {finalOption?.text}
            </Typography>
          )}
        </Stack>
      </Stack>
    </AnimatePresence>
  )
}

const PreText = ({
  showText,
  text = 'Ưu đãi lớn cho anh em! ',
}: {
  showText: boolean
  text?: string | undefined
}) => {
  if (!showText) return null
  return (
    <Typography
      sx={{
        color: 'five.main',
        fontSize: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        mr: 0.25,
      }}
    >
      <img src={URL_ICON + 'sale.png'} alt="Khuyến mãi đang diễn ra" className="w-[1.2em] animate-[spin_3s_linear_infinite]" />
      <Typography
        component={'span'}
        sx={{
          fontSize: 'inherit',
          textTransform: 'uppercase',
          fontWeight: 600,
          display: { xs: 'none', lg: 'block' },
        }}
      >
        {text}{' '}
      </Typography>
    </Typography>
  )
}
